import {
    BASE_URL,
    CHECKOUT_PATH,
    ONLY_CHECKOUT_PATH,
    ORDER_SUCCESS_ANIMATION_PATH,
    PAY_IN_PATH,
    PRE_ORDER_CONFIRMATION_ORGANIZER_QUESTIONS_PATH,
    PRE_TICKETS_ORGANIZER_QUESTIONS_PATH,
    TICKETS_COMPACT_SIZE_PATH,
    TICKETS_FULL_SIZE_PATH,
} from '../constants';
import { CheckoutState } from '../state';

export const getRoutePathname = (state: CheckoutState) =>
    state?.routing?.locationBeforeTransitions?.pathname;

export const getIsOrderSuccessAnimationPage = (state: CheckoutState) =>
    getRoutePathname(state) === `${BASE_URL}/${ORDER_SUCCESS_ANIMATION_PATH}`;

export const getIsPaymentView = (state: CheckoutState) =>
    getRoutePathname(state) === `${BASE_URL}/${CHECKOUT_PATH}`;

export const isOrganizerQuestionsPage = (state: CheckoutState) =>
    getRoutePathname(state) ===
    `${BASE_URL}/${PRE_ORDER_CONFIRMATION_ORGANIZER_QUESTIONS_PATH}`;

export const isMyOrderFormPage = (state: CheckoutState) =>
    getRoutePathname(state) ===
    `${BASE_URL}/${PRE_TICKETS_ORGANIZER_QUESTIONS_PATH}`;

export const isOnlyCheckoutPage = (state: CheckoutState) =>
    getRoutePathname(state) === `${BASE_URL}/${ONLY_CHECKOUT_PATH}`;

export const isPayInPage = (state: CheckoutState) =>
    getRoutePathname(state) === `${BASE_URL}/${PAY_IN_PATH}`;

export const isTicketsCompactPage = (state: CheckoutState) =>
    getRoutePathname(state) === `${BASE_URL}/${TICKETS_COMPACT_SIZE_PATH}`;

export const isTicketSelectionFullSizePage = (state: CheckoutState) =>
    getRoutePathname(state) === `${BASE_URL}/${TICKETS_FULL_SIZE_PATH}`;
